import { render, staticRenderFns } from "./groupOperationModal.vue?vue&type=template&id=60004384&scoped=true&"
import script from "./groupOperationModal.vue?vue&type=script&lang=ts&"
export * from "./groupOperationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60004384",
  null
  
)

export default component.exports